import get from 'lodash/get';
import { fetchItemGroups } from './item-groups.utils';
import { createFrozenMap } from '@/vuex/utils';

const SET_ERROR = 'setError';
const SET_FETCHING = 'setFetching';
const SET_MAP = 'setMap';

export default {
    namespaced: true,
    state: {
        map: {},
        error: {},
        fetching: false,
    },
    mutations: {
        [SET_MAP] (state, { map }) {
            state.map = map;
        },
        [SET_ERROR] (state, { error }) {
            state.error = error;
        },
        [SET_FETCHING] (state, { fetching }) {
            state.fetching = fetching;
        },
    },
    actions: {
        async loadAll ({ commit }) {
            commit(SET_FETCHING, { fetching: true });
            try {
                const { data: itemGroups } = await fetchItemGroups();
                const map = createFrozenMap(itemGroups, 'pendo_itemgroup_id');
                commit(SET_MAP, { map });
            } catch (fetchingError) {
                commit(SET_ERROR, { error: fetchingError });
                throw fetchingError;
            } finally {
                commit(SET_FETCHING, { fetching: false });
            }
        },
    },
    getters: {
        groupCasesCount: (state) => (id) => get(state, ['map', id, 'cases_count'], 0),
    },
};
